import { React } from 'react'
import { slug, icap, tr } from '../../../../global-pure.js'
import PageLayout from '../../../../containers/page/PageLayout.jsx'
import cardPic from '../../../../assets/courses/distros.png'

export const card = {
  title: 'delivery-milk:title',
  subtitle: 'delivery-milk:subtitle',
  description: 'test',
  routeBuilder: () => `/${slug(tr('contact'))}?n=1&m=${tr('I am interested in doing @').replace('@', `${tr('delivery')}, ${tr(card.title)}, ${tr(card.subtitle)}`)}`,
  imgUrl: cardPic,
  call: 'inquire now',
}

const Job = () => {
  return (
    <PageLayout>
      <div className='side-divider'>
        <div className='content'>
          <h1>{icap(tr(card.title))}</h1>
          <h2>{tr(card.subtitle)}</h2>
        </div>
      </div>
    </PageLayout>
  )
}

export default Job